import { render, staticRenderFns } from "./GalleryFilterHeader.vue?vue&type=template&id=4d81cfa6"
import script from "./GalleryFilterHeader.vue?vue&type=script&lang=js"
export * from "./GalleryFilterHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports